import { combineReducers } from 'redux';

import { reducer as localesReducer } from './locales/locales.redux';
import { reducer as contentReducer } from './contentRegistry/contentRegistry.redux';
import { reducer as marketReducer } from './market/market.redux';
import { reducer as experienceReducer } from './experience/experience.redux';
import { reducer as kioskReducer } from './kiosk/kiosk.redux';
import { reducer as headerBarReducer } from './headerBar/headerBar.redux';
import { reducer as authReducer } from './auth/auth.redux';
import { reducer as bookingReducer } from './booking/booking.redux';
import { reducer as snackbarReducer } from './snackbar/snackbar.redux';
import { reducer as idleTimeoutReducer } from './idleTimeout/idleTimeout.redux';
import { reducer as overlayReducer } from './overlay/overlay.redux';
import { reducer as cancellationReducer } from './cancellation/cancellation.redux';
import { reducer as legalReducer } from './legal/legal.redux';
import { reducer as filtersReducer } from './filters/filters.redux';
import { reducer as filteredReducer } from './filtered/filtered.redux';
import { reducer as userReducer } from './user/user.redux';
import { reducer as itineraryReducer } from './itinerary/itinerary.redux';
import { reducer as analyticsReducer } from './analytics/analytics.redux';
import { reducer as routerReducer } from './router/router.redux';
//<-- IMPORT MODULE REDUCER -->

export default function createReducer() {
  return combineReducers({
    locales: localesReducer,
    content: contentReducer,
    market: marketReducer,
    experience: experienceReducer,
    kiosk: kioskReducer,
    headerBar: headerBarReducer,
    booking: bookingReducer,
    auth: authReducer,
    snackbar: snackbarReducer,
    idleTimeout: idleTimeoutReducer,
    overlay: overlayReducer,
    legal: legalReducer,
    cancellation: cancellationReducer,
    filters: filtersReducer,
    filtered: filteredReducer,
    analytics: analyticsReducer,
    user: userReducer,
    itinerary: itineraryReducer,
    router: routerReducer,
    //<-- INJECT MODULE REDUCER -->
  });
}
